import Vue from 'vue';
import moment from 'moment';

import { LogStorage, Message, LoggerSetting } from '@/models/log.models';
import { actions as _act } from '@/models/store.actions';
import * as act from '@/store/log.actions';
import store from '@/store/store';
import { AppLogLevel } from '@/models/enums';

// obsolete. required to upgrade log storage
enum eMessageTypes {
  Success = 1,
  Warning,
  Error,
  Info
};

const state = new LogStorage();

const actions = {};

const mutations = {
  [act.MUT_MESSAGE](state: LogStorage, payload: { message: Message, email?: string }): void {
    let { message, email } = payload || {};
    if (message) {
      if (typeof email === 'undefined') {
        email = currentUserEmail();
      }
      if (email) {
        if (email in state.messages === false) {
          state.messages[email] = [];
        }
        let idx = state.messages[email].findIndex(m => m.id === message.id);
        if (idx > -1) {
          state.messages[email].splice(idx, 1, message);
        } else {
          if (state.messages[email].length >= 500) {
            state.messages[email].splice(0, 100);
          }
          state.messages[email].push(message);
        }
      }
    }
  },
  [act.MUT_MESSAGES](state: LogStorage, payload: { messages: Array<Message>, email?: string }): void {
    let { messages, email } = payload || {};
    if (typeof email === 'undefined') {
      email = currentUserEmail();
    }
    if (email) {
      state.messages[email] = messages;
    }
  },
  [act.MUT_CLEAROLDSTATE](state: any): void {
    delete state.alertText;
    delete state.alertType;
    delete state.logs;
    delete state.showAlert;
  },
  [act.MUT_MARK_MESSAGE_AS_REPORTED](state: LogStorage, id: string): void {
    let email = currentUserEmail();
    if (id &&
      email &&
      email in state.messages &&
      state.messages[email] &&
      state.messages[email].length) {
      let msgIndex = state.messages[email].findIndex(m => m.id === id);
      if (msgIndex > -1) {
        state.messages[email][msgIndex].dateReported = moment().format('DD/MM/YYYY HH:mm:ss');
      }
    }
  },
  [act.MUT_REMOVE_MESSAGES](state: LogStorage, payload: { ids: string[], email?: string }): void {
    let { ids, email } = payload || {};
    if (ids && ids.length) {
      if (typeof email === 'undefined') {
        email = currentUserEmail();
      }
      if (email in state.messages &&
        state.messages[email] &&
        state.messages[email].length) {
        state.messages[email] = state.messages[email].filter(m => !ids.includes(m.id));
      }
    }
  },
  [act.MUT_REMOVE_ALL_MESSAGES](state: LogStorage, email?: string): void {
    if (typeof email === 'undefined') {
      email = currentUserEmail();
    }
    Vue.set(state.messages, email, []);
  },
  [act.MUT_SETTINS](state: LogStorage, settings: LoggerSetting): void {
    Vue.set(state.settings, currentUserEmail(), settings);
  },
  [act.MUT_VERSION](state: LogStorage, version: string): void {
    state.version = version;
  }
};

const getters = {
  [act.GET_MESSAGES]: (state: LogStorage) => {
    return (email?: string) => {
      if (typeof email === 'undefined') {
        email = currentUserEmail();
      }
      let messages = state.messages[email];
      return messages;
    };
  },
  [act.GET_MESSAGE]: (state: LogStorage) => {
    return (id) => {
      let message;
      let email = currentUserEmail();
      if (email && email in state.messages) {
        let messages = state.messages[email];
        if (messages && messages.length) {
          message = messages.find(m => m.id === id);
        }
      }
      return message;
    };
  },
  [act.GET_SETTINGS]: (state: LogStorage) => {
    let settings = state.settings[currentUserEmail()];
    return settings;
  },
  [act.GET_VERSION]: (state: LogStorage) => {
    return state.version;
  }
};

/* Helpers */
function currentUserEmail(): string {
  return store.getters[_act.AUTH_GET_EMAILUSERGET] || '';
}

export const log = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

export function logStorePlugin(store: any) {
  let { log } = store.state;
  if ('logs' in log) {
    store.commit(_act.LOG_MUT_CLEAROLDSTATE);
  }
  upgradeToVersion2(store);
}

function upgradeToVersion2(store: any) {
  let { log } = store.state;
  let version = store.getters[_act.LOG_GET_VERSION];
  if (version === '1.0.0.0') {
    store.commit(_act.LOG_MUT_REMOVE_ALL_MESSAGES, '');
    for (let email in log.messages) {
      let messages = store.getters[_act.LOG_GET_MESSAGES](email);
      let upgradedMessages = messages
        .filter(m => m.type !== eMessageTypes.Success)
        .map(m => {
          m.level = mapMessageTypeToLogLevel(m.type);
          delete m.type;
          delete m.typeString;
          return m;
        });
      store.commit(_act.LOG_MUT_MESSAGES, { messages: upgradedMessages, email });
    }
    store.commit(_act.LOG_MUT_VERSION, '2.0.0.0');
  }
}

function mapMessageTypeToLogLevel(type: eMessageTypes): string {
  let level;
  if (type === eMessageTypes.Error) {
    level = AppLogLevel[AppLogLevel.Error];
  } else if (type === eMessageTypes.Warning) {
    level = AppLogLevel[AppLogLevel.Warning];
  } else if (type === eMessageTypes.Info) {
    level = AppLogLevel[AppLogLevel.Info];
  }
  return level;
}
